import { render, staticRenderFns } from "./Trick.vue?vue&type=template&id=454b9192&scoped=true&"
import script from "./Trick.vue?vue&type=script&lang=js&"
export * from "./Trick.vue?vue&type=script&lang=js&"
import style0 from "./Trick.vue?vue&type=style&index=0&id=454b9192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b9192",
  null
  
)

export default component.exports